import focus from './focus';

const install = (app: any) => {
  app.directive(focus.name, focus.hooks);
};

export default {
  install,
};
